import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { Button, Collapse, InputGroup, NavbarBrand, Navbar, Nav, NavbarToggler } from "reactstrap";
import NotificationDropdown from "./NotificationDropdown";
import UserDropdown from "./UserDropdown";
import {LanguageDropdown} from "./LanguageDropdown";
import SearchModal from "components/modals/SearchModal";
import Logo from "components/sidebar/Logo";
import { Link } from "react-router-dom";

function AdminNavbar({ sidebarOpened, toggleSidebar, brandText, logo }) {
    const [collapseOpen, setCollapseOpen] = useState(false);
    const [modalSearch, setModalSearch] = useState(false);
    const [color, setColor] = useState("navbar-transparent");

    const updateColor = useCallback(() => {
        setColor(window.innerWidth < 993 && collapseOpen ? "bg-white" : "navbar-transparent");
    }, [collapseOpen]);

    useEffect(() => {
        window.addEventListener("resize", updateColor);
        return () => {
            window.removeEventListener("resize", updateColor);
        };
    }, [updateColor]);

    const handleToggleCollapse = useCallback(() => {
        setColor(prevColor => (prevColor === "navbar-transparent" ? "bg-white" : "navbar-transparent"));
        setCollapseOpen(prevCollapseOpen => !prevCollapseOpen);
    }, []);

    const handleToggleModalSearch = useCallback(() => {
        setModalSearch(prevModalSearch => !prevModalSearch);
    }, []);

    return (
        <>
            <Navbar className={classNames("navbar-absolute navbar navbar-expand-lg", color)}>
                <div className="navbar-wrapper">
                    <div className={classNames("navbar-toggle d-inline", { toggled: sidebarOpened })}>
                        <NavbarToggler onClick={toggleSidebar}>
                            <span className="navbar-toggler-bar bar1" />
                            <span className="navbar-toggler-bar bar2" />
                            <span className="navbar-toggler-bar bar3" />
                        </NavbarToggler>
                    </div>
                    <NavbarBrand tag={Link} to="/admin/dashboard" className="d-flex align-items-center">
                        <Logo logo={logo} />
                        {brandText}
                    </NavbarBrand>
                </div>
                <NavbarToggler onClick={handleToggleCollapse}>
                    <span className="navbar-toggler-bar navbar-kebab" />
                    <span className="navbar-toggler-bar navbar-kebab" />
                    <span className="navbar-toggler-bar navbar-kebab" />
                </NavbarToggler>
                <Collapse className="collapse navbar-collapse" navbar isOpen={collapseOpen}>
                    <Nav className="navbar-nav ms-auto" navbar>
                        {/*<InputGroup className="search-bar">
                            <Button color="link" onClick={handleToggleModalSearch}>
                                <i className="tim-icons icon-zoom-split" />
                                <span className="d-lg-none d-md-block">Search</span>
                            </Button>
                        </InputGroup>*/}
                        <NotificationDropdown />
                        <LanguageDropdown />
                        <UserDropdown />
                        <li className="separator d-lg-none" />
                    </Nav>
                </Collapse>
            </Navbar>
            <SearchModal isOpen={modalSearch} toggle={handleToggleModalSearch} />
        </>
    );
}

export default AdminNavbar;
